import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { berlinToday } from '@pm-tool/shared';
import {
  parseHeatmapSearch,
  resolveHeatmapSearch,
} from '@/features/resources/heatmap/heatmap-search';
import { PersonResources } from '@/features/resources/heatmap/person-resources';
import { personResourcesQuery } from '@/features/resources/resources-api';
import { resourceTexts } from '@/features/resources/texts';

/** RES-12: one person's utilization per project, for the resource planning. */
export const Route = createFileRoute('/_app/resources/people/$userId')({
  validateSearch: (raw: Record<string, unknown>) => parseHeatmapSearch(raw),
  component: RouteComponent,
});

function RouteComponent() {
  const { userId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const view = resolveHeatmapSearch(search, berlinToday(new Date()));
  // Same query as the view below (cached): only for the heading.
  const person = useQuery(
    personResourcesQuery(userId, {
      from: view.range.from,
      to: view.range.to,
      granularity: view.granularity,
    }),
  );
  return (
    <div className="flex flex-col gap-4">
      {person.data === undefined ? null : (
        <h2 className="text-xl font-semibold">
          {resourceTexts.myResources.titleOf(person.data.user.name)}
        </h2>
      )}
      <PersonResources
        target={userId}
        search={search}
        onSearchChange={(next) => {
          void navigate({ search: next, replace: true });
        }}
      />
    </div>
  );
}
